import { useDCAuthStore } from "../store";
import { DCAuthMethods } from "../types";

export const useDCAuth = () => {
  const { user, loading, error, clearError } = useDCAuthStore();
  
  // Acceso a los métodos de autenticación desde window.dcAuth
  const getAuthMethods = (): DCAuthMethods => {
    if (typeof window !== "undefined" && (window as any).dcAuth) {
      return (window as any).dcAuth;
    }
    throw new Error("DCAuth no está inicializado. Asegúrate de envolver tu app con <DCAuth>");
  };

  return {
    user,
    loading,
    error,
    clearError,
    isAuthenticated: !!user,
    loginWithEmail: (email: string, password: string) => 
      getAuthMethods().loginWithEmail(email, password),
    loginWithGoogle: () => 
      getAuthMethods().loginWithGoogle(),
    logout: () => 
      getAuthMethods().logout(),
    updateProfile: (profile: { displayName?: string; photoURL?: string }) =>
      getAuthMethods().updateProfile(profile),
  };
};
